// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { NetworkPolling } from './NetworkPolling';
import { WebsocketClearCache } from './WebsocketClearCache';
import { WebsocketToggle } from './WebsocketToggle';

export const AllSettings: React.FC = () => {
  return (
    <>
      <NetworkPolling />
      <WebsocketToggle />
      <WebsocketClearCache />
    </>
  );
};
